import { render, staticRenderFns } from "./InstructorProfile.vue?vue&type=template&id=2e367f36&scoped=true"
import script from "./InstructorProfile.vue?vue&type=script&lang=js"
export * from "./InstructorProfile.vue?vue&type=script&lang=js"
import style0 from "./InstructorProfile.vue?vue&type=style&index=0&id=2e367f36&prod&scoped=true&lang=css"
import style1 from "./InstructorProfile.vue?vue&type=style&index=1&id=2e367f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e367f36",
  null
  
)

export default component.exports